// Live filter chip labels for filter bars that never re-render themselves.
//
// A form with [data-filter-live] swaps only its results region, so the bar keeps
// its open dropdown and its checkbox state across a filter change. The cost is
// that the server-rendered chip label — "Status (2)" and .chip-active — goes
// stale, because nothing re-renders it. Recompute it here from the inputs the
// operator just changed, which are the same values the request carried.
//
// Counts only inputs with a value: the "Any assignee" radio is value="" and
// means no filter, so it must not light the chip up.
(function () {
    function refresh(form) {
        form.querySelectorAll('[data-filter-chip-count]').forEach(function (label) {
            var chip = label.closest('.chip');
            var name = label.getAttribute('data-filter-chip-count');
            var count = 0;
            // form.elements includes controls in menus portaled to body.
            Array.from(form.elements).forEach(function (input) {
                if (input.name === name && input.checked && input.value !== '') count += 1;
            });
            chip.classList.toggle('chip-active', count > 0);
            label.textContent = count ? ' (' + count + ')' : '';
        });
    }

    document.addEventListener('change', function (e) {
        var form = e.target.form || e.target.closest('form[data-filter-live]');
        if (!form || !form.matches('[data-filter-live]')) return;
        refresh(form);
        // Associated controls outside the form cannot bubble to its HTMX trigger.
        // In-form changes already trigger it, so forward only portaled controls.
        if (!form.contains(e.target)) window.htmx.trigger(form, 'change');
    });

    // The form serializes every field, so an untouched search box and the three
    // "Any ..." radios would push ?q=&assignee=&creator=&plan= into the address
    // bar and into every shareable link. The view reads a missing key and an
    // empty one the same way, so drop the empties before the request goes out.
    document.body.addEventListener('htmx:configRequest', function (e) {
        var elt = e.detail.elt;
        if (!elt || !elt.closest || !elt.closest('form[data-filter-live]')) return;
        var params = e.detail.parameters;
        if (typeof params.delete !== 'function') {  // htmx 1.x handed over a plain object
            Object.keys(params).forEach(function (key) {
                if (params[key] === '') delete params[key];
            });
            return;
        }
        // delete() drops every value under a key, so only drop keys that are
        // empty all the way down — a checkbox group never is.
        var keys = [];
        params.forEach(function (_value, key) {
            if (keys.indexOf(key) === -1) keys.push(key);
        });
        keys.forEach(function (key) {
            if (params.getAll(key).every(function (value) { return value === ''; })) params.delete(key);
        });
    });
})();
